import { render, staticRenderFns } from "./announce.vue?vue&type=template&id=7e5dfe3a&scoped=true&"
import script from "./announce.vue?vue&type=script&lang=js&"
export * from "./announce.vue?vue&type=script&lang=js&"
import style0 from "./announce.vue?vue&type=style&index=0&id=7e5dfe3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e5dfe3a",
  null
  
)

export default component.exports